export const environment = {
  production: true,
  buildId: '3046005692520151',
  configFile: 'config.json',
};
